import React from 'react'

const NavList = ({ ul_class, li_class, close_click }) => {
    return (
        <ul className={`${ul_class}`}>
            <li className={`${li_class}`}><a href="/" onClick={close_click ? close_click : close_click}>Home</a></li>
            <li className={`${li_class}`}><a href="#about" onClick={close_click ? close_click : close_click}>About</a></li>
            <li className={`${li_class}`}><a href="#tarrif" onClick={close_click ? close_click : close_click}>Tarrif</a></li>
            <li className={`${li_class}`}><a href="#ourservices" onClick={close_click ? close_click : close_click}>Our Services</a></li>
            <li className={`${li_class}`}><a href="#contact" onClick={close_click ? close_click : close_click}>Contact</a></li>
        </ul>
    )
}

export default NavList